module.exports = __webpack_public_path__ + "static/img/5.e2fd45e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/5.png
// module id = VPt8
// module chunks = 0